import React from 'react'
import styles from './MicrositePlanBadge.module.css'

/**
 * MicrositePlanBadge
 * Colored pill for plan tier name (Free / Pro / Enterprise / custom).
 *
 * Usage:
 *   <MicrositePlanBadge planName="Pro" />
 */
const TONE_MAP = {
    free: 'neutral',
    pro: 'blue',
    enterprise: 'gold'
}

const MicrositePlanBadge = ({ planName = 'Free' }) => {
    const tone = TONE_MAP[planName.toLowerCase()] || 'blue'
    return (
        <span className={`${styles.badge} ${styles[`tone_${tone}`]}`}>
            {planName}
        </span>
    )
}

export default MicrositePlanBadge